import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { GENERAL_ROUTES } from "../../routes/routes";

interface LoginBaseRouteProps {}

export const LoginRedirect: React.FC<LoginBaseRouteProps> = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(GENERAL_ROUTES.Index);
  }, []);

  return null;
};
